{
  "accept": "Accept",
  "action": "Action",
  "allCountries": "All Countries",
  "allPayments": "All Payment Methods",
  "allTypes": "All Types",
  "amount": "Amount",
  "asset": "Asset",
  "buy": "Buy",
  "buyer": "Buyer",
  "cancel": "Cancel",
  "cancelFailed": "Order cancellation failed.",
  "cancelled": "Cancelled",
  "completed": "Completed",
  "country": "Country",
  "createP2pAd": "Create P2P Ad",
  "dispute": "Dispute",
  "disputeReason": "Dispute Reason",
  "escrow": "Escrow",
  "escrowActive": "Escrow Active",
  "escrowProtection": "Escrow Protection",
  "escrowReady": "Escrow Ready",
  "fillAllFields": "Please fill all required fields.",
  "global": "Global",
  "globalP2pTrading": "Global P2P Trading",
  "inEscrow": "In Escrow",
  "inTrade": "In Trade",
  "liveGlobalAds": "Live Global Ads",
  "loading": "Loading...",
  "markPaid": "Mark Paid",
  "noP2pAdsFound": "No P2P ads found.",
  "offline": "Offline",
  "online": "Online",
  "open": "Open",
  "openDispute": "Open Dispute",
  "orderCancelledRefunded": "Order cancelled and the locked asset was refunded.",
  "orderDetails": "Order Details",
  "orderId": "Order ID",
  "p2pOrderCreated": "P2P order created successfully.",
  "p2pSecurity": "P2P Security",
  "p2pSecurity1": "User-to-user trading",
  "p2pSecurity2": "Live database orders",
  "p2pSecurity3": "Escrow status tracking",
  "p2pSecurity4": "Payment proof upload",
  "p2pSecurity5": "Administrator review support",
  "p2pSecurity6": "Secure P2P status workflow",
  "p2pSubtitle": "Buy and sell crypto worldwide with secure escrow protection.",
  "p2pTitle": "Global P2P Trading",
  "payment": "Payment",
  "paymentMethod": "Payment Method",
  "paymentProof": "Payment Proof",
  "paymentSent": "Payment Sent",
  "paymentSubmitted": "Payment proof submitted successfully.",
  "pleaseLoginFirst": "Please login first.",
  "price": "Price",
  "processing": "Processing...",
  "release": "Release",
  "releaseFailed": "Asset release failed.",
  "selectPaymentMethod": "Select Payment Method",
  "sell": "Sell",
  "seller": "Seller",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "status": "Status",
  "totalOrders": "Total Orders",
  "tradeCompletedSuccessfully": "Trade completed successfully.",
  "tradeFailed": "Trade failed.",
  "tradeStartedSuccessfully": "Trade started successfully.",
  "trader": "Trader",
  "unknownTrader": "Trader",
  "uploadPaymentProof": "Please upload payment proof.",
  "uploadProof": "Upload Proof",
  "verifiedMerchant": "Verified Merchant",
  "waitingEscrow": "Waiting for Escrow",
  "walletAddress": "Wallet Address"
}